export const ADMIN = '7a120e29-78b3-419f-92fb-1c9b04e9aac3';
export const AUCTION_HOUSE = '1f1770b2-b79f-4625-b841-2e08d6de1f54';
export const CUSTOMER = 'db5ad146-feb5-4744-8fb1-85b7c302d39a';
export const SHIPPER = 'c0bca475-8aa5-4f25-b050-1b71e879dd03';
